define('type/article/Serum.FeatureArticle',[
  './Serum.CommentThread',
  'common/module/date/Serum.Date',
  './Serum.Article.UniverseRelationDerepetizer',
  './Serum.Article.Note'
], function(CommentThread, SerumDate, UniverseRelationDerepetizer, Note){
  'use strict';

  var SELECTOR_COVER = '.article-feature__cover';
  var SELECTOR_MORE_BTN = '.article-feature__intro > .nrk-button';
  var SELECTOR_TIMES = '.article-feature time[datetime]';
  var SELECTOR_FACTS = '.article-feature > .fr.fact-reference';
  var SELECTOR_COMMENTS = '.article-feature .article-comments';

  function setHumanDiff(){
    [].forEach.call(document.querySelectorAll(SELECTOR_TIMES), function(el){
      el.innerHTML = new SerumDate(el.getAttribute('datetime')).getHtml();
    });
  }

  function setupComments(){
    [].forEach.call(document.querySelectorAll(SELECTOR_COMMENTS), function(el){
      CommentThread.initialize(el);
    });
  }

  function setupFactCollapse(){
    //Loop all right-aligned fact references
    [].forEach.call(document.querySelectorAll(SELECTOR_FACTS), function(node){
      var fact = node.querySelector('.fact');
      var factClosedClass = fact.className.replace(/\bfact--full\b/, '');
      var factBottomPixel = fact.offsetTop + fact.offsetHeight;

      while((node = node.nextElementSibling)){
        if(node.offsetTop > factBottomPixel){     //If first node after fact
          if(node.offsetLeft < fact.offsetLeft){  //Is also left of fact
            fact.className = factClosedClass;     //Then close it
          }
          break;
        }
      }
    });
  }

  function showAllAuthors(event) {
    var container, authors;

    if(event.target.hash === '#authors--expand'){
      event.preventDefault();
      container = event.target.parentElement;
      container.removeChild(event.target);
      authors = container.querySelectorAll('.author');
      authors[1].querySelector('a').focus();
    }
  }

  function showCoverFullscreen(event){
    var cover = document.querySelector(SELECTOR_COVER);
    var moreBtn = document.querySelector(SELECTOR_MORE_BTN);
    var active = ' is-fullscreen';

    //Only .picture can go fullscreen
    if(cover.querySelector('.picture') && (cover.contains(event.target) || moreBtn === event.target)){
      event.preventDefault();
      cover.className = (cover.className + active).replace(active + active, '');
    }
  }

  return {
    initialize: function(){
      setHumanDiff();
      setupComments();
      setupFactCollapse();
      document.addEventListener('click', showAllAuthors);
      document.addEventListener('click', showCoverFullscreen);
      UniverseRelationDerepetizer.derepetize(document.querySelector('.article-feature~section'));
      Note.initialize(document.querySelector('.article-feature__body'));
    },
    destroy: function(){
      document.removeEventListener('click', showAllAuthors);
      document.removeEventListener('click', showCoverFullscreen);
    }
  };
});

